import { BMEventsType } from '../types';
import { custom, interaction } from './core';
const concurrentMetrics = {};

const getKey = (config, type) => `${type}--${config.key}`;

const validateConfig = config => {
  if (config.include) {
    throw new Error('"include" is not supported in concurrent actions');
  }

  if (config.until) {
    throw new Error('"until" is not supported in concurrent actions');
  }
};

const ensurePath = (config, type) => {
  const key = getKey(config, type);

  if (!(key in concurrentMetrics)) {
    concurrentMetrics[key] = {};
  }
};

const getMetricFromCache = (concurrentId, config, type) => {
  const concurrentKey = getKey(config, type);

  if (concurrentKey in concurrentMetrics && concurrentMetrics[concurrentKey][String(concurrentId)]) {
    return concurrentMetrics[concurrentKey][String(concurrentId)];
  }

  if (!(concurrentKey in concurrentMetrics)) {
    concurrentMetrics[concurrentKey] = {};
  }
};

const makeConcurrentMetric = (concurrentId, config, type) => {
  validateConfig(config);
  ensurePath(config, type);
  const metricFromCache = getMetricFromCache(concurrentId, config, type);

  if (metricFromCache) {
    return metricFromCache;
  }

  const metricFactory = type === BMEventsType.INLINE_RESULT ? interaction : custom;
  const metric = metricFactory(config);
  concurrentMetrics[getKey(config, type)][String(concurrentId)] = metric;
  return metric;
};

export const concurrent = {
  pageSegmentLoad: config => concurrentId => makeConcurrentMetric(concurrentId, { ...config
  }, BMEventsType.PAGE_SEGMENT_LOAD),
  interaction: config => concurrentId => makeConcurrentMetric(concurrentId, { ...config
  }, BMEventsType.INLINE_RESULT),
  custom: config => concurrentId => makeConcurrentMetric(concurrentId, { ...config
  }, BMEventsType.CUSTOM)
};